document.querySelectorAll('.testimonial-carousel').forEach(function (root) {
  var slides = Array.prototype.slice.call(root.querySelectorAll('.testimonial-carousel__slide'));
  if (slides.length < 2) return;
  var index = 0;
  function show(i) {
    slides[index].classList.remove('is-active');
    index = (i + slides.length) % slides.length;
    slides[index].classList.add('is-active');
  }
  var prev = root.querySelector('.testimonial-carousel__arrow--prev');
  var next = root.querySelector('.testimonial-carousel__arrow--next');
  if (prev) prev.addEventListener('click', function () { show(index - 1); });
  if (next) next.addEventListener('click', function () { show(index + 1); });
});
